module.exports = __webpack_public_path__ + "static/media/Rishabh_Katiyar.jpg:Zone.a02069d7.Identifier";